import {IUser} from '@wix/native-components-infra/dist/src/types/types'

const initialData = {
  id: null,
  role: null,
  loggedIn: false,
}

export const currentUser = (state: Partial<IUser> = initialData) => state
